import { faCheck, faUndo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { IVeiculos } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"
import { currencyFormatter } from "../../utils/currencyFormatter"
import { maskNumber } from "../../utils/masks"
import "./style.css"

type ParamsProps = {
  tipo: "new" | "edit"
}

type IParams = {
  id: string
}

export function VeiculosForm({ tipo }: ParamsProps) {
  const navigate = useNavigate()

  const { id } = useParams() as IParams
  const { tokens, checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [cadastro, setCadastro] = useState<IVeiculos>({} as IVeiculos)

  const loadCadastro = useCallback(async () => {
    setLoading(true)
    setTxtLoading("Carregando cadastro...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.get(`veiculos/${id}`)
      .then((res) => {
        if (!res.data)
          return

        const cad = res.data as IVeiculos

        setCadastro({
          ...cad,
          autonomia: currencyFormatter(parseFloat(`${cad.autonomia}`), false),
          km: maskNumber(`${cad.km}`)
        })
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao carregar o cadastro. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, id])

  const handleSalvar = async () => {
    if (parseInt((`${cadastro.km}`).replace(/\D/g, "")) <= 0)
      return alert("Informe o Km do veículo")

    setLoading(true)
    setTxtLoading("Salvando...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    try {
      await api.post("veiculos", {
        ...cadastro,
        autonomia: parseFloat((`${cadastro.autonomia}`).replace(".", "").replace(",", ".")),
        km: parseInt((`${cadastro.km}`).replace(/\D/g, ""))
      })

      navigate("/veiculos")
    } catch (err: any) {
      if (err.response?.data?.message)
        alert(err.response?.data?.message);
      else
        alert("Erro ao salvar. Tente novamente mais tarde.");

      setLoading(false);
      setTxtLoading("");
    }
  }

  useEffect(() => {
    if (tokens?.token && tipo === "edit")
      loadCadastro()
  }, [tokens, tipo, loadCadastro])

  return (
    <div id="pgVeiculosForm">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>
          <div className="painel form">
            <p className="title">{tipo === "new" ? "Novo" : "Editando"} Cadastro</p>

            <span style={{ width: "49%" }}>
              <label>Nome</label>
              <Input
                mask="none"
                value={`${cadastro.nome ? cadastro.nome : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, nome: v }))}
                placeholder="Nome"
              />
            </span>

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>KM</label>
              <Input
                mask="number"
                value={`${cadastro.km ? cadastro.km : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, km: v }))}
                placeholder="Km atual do veículo"
                type="tel"
              />
            </span>

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>Autonomia</label>
              <Input
                mask="currency"
                value={`${cadastro.autonomia ? cadastro.autonomia : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, autonomia: v }))}
                placeholder="0,00"
                type="tel"
              />
            </span>

          </div>

          <div className="btnPainel">
            <button className="btn-purple" onClick={() => { navigate(-1) }}>
              <FontAwesomeIcon icon={faUndo} />
              VOLTAR
            </button>

            <button className="btn-green" onClick={() => { handleSalvar() }}>
              <FontAwesomeIcon icon={faCheck} />
              SALVAR
            </button>
          </div>
        </>
      )}

    </div>
  )
}